import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, InstagramPost } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: []
}

const slice = createSlice({
  name: 'cms/instagramFeed',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<InstagramPost[]>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

const INSTAGRAM_FEED_LIMIT = 4

export function fetchInstagramFeed (limit = INSTAGRAM_FEED_LIMIT): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().cms.fetchInstagramFeed({
        limit
      })

      const { data } = response
      const { visitureInstagramPost } = data
      if (visitureInstagramPost) {
        dispatch(success(visitureInstagramPost.items))
      } else {
        dispatch(failure())
      }
      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
